
<div>
  <div id="edit-group-dialog" class="ui mini modal">
    <i class="close icon"></i>
    <div v-if="form.model.id" class="header">グループ情報編集</div>
    <div v-else class="header">グループ新規作成</div>
    <div class="content">
      <form class="ui form" :class="{'warning': form.hasErrors()}">
        <div class="required field">
          <label>グループ名</label>
          <input v-model="form.model.name" type="text" placeholder="グループ名">
          <validation-message :form="form" :field="'name'"></validation-message>
        </div>
        <div v-if="!form.model.id" class="required field">
          <label>ログインID</label>
          <input v-model="form.model.login_id" type="text" placeholder="ログインID">
          <validation-message :form="form" :field="'login_id'"></validation-message>
        </div>
        <div class="required field">
          <label>パスワード</label>
          <input v-model="form.model.password" type="text" placeholder="パスワード">
          <validation-message :form="form" :field="'password'"></validation-message>
        </div>
      </form>
    </div>
    <div class="actions">
      <div class="ui cancel button">閉じる</div>
      <div class="ui green button" :class="{'loading disabled': form.waiting}" @click="save()">保存する</div>
    </div>
  </div>
  <div class="action-menu">
    <button type="button" class="ui small positive button" @click="openDialog()">
      <i class="plus icon"></i>新規登録
    </button>
  </div>
  <form class="ui form" :class="{'loading': loadForm.waiting}">
    <table class="ui compact selectable table">
      <thead>
        <tr>
          <th>グループ名</th>
          <th>ログインID</th>
          <th>パスワード</th>
          <th>店舗数</th>
          <th class="actions">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="group in groups" :key="group.id">
          <td>{{ group.name }}</td>
          <td>{{ group.user.login_id }}</td>
          <td>{{ group.user.plain_password }}</td>
          <td><a :href="'/afadmin/shops?group_id=' + group.id">{{ group.shops.length }}店舗</a></td>
          <td class="actions">
            <button type="button" class="ui inverted tiny positive basic button" @click="openDialog(group)">編集</button>
            <button type="button" class="ui inverted tiny negative basic button" @click="remove(group)">削除</button>
          </td>
        </tr>
      </tbody>
    </table>
  </form>
</div>
